import { render } from "./MyPolls.vue?vue&type=template&id=abe8dbbe&scoped=true"
import script from "./MyPolls.vue?vue&type=script&lang=js"
export * from "./MyPolls.vue?vue&type=script&lang=js"

import "./MyPolls.vue?vue&type=style&index=0&id=abe8dbbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe8dbbe"]])

export default __exports__